export enum CommonColors {
  Primary = "primary",
  Light = "light",
  Neutral = "neutral",
  Dark = "dark",
  Glass = "glass",
  Wood = "wood",
  Stone = "stone",
  Materia = "materia",
  Metal = "metal",
  NeutralLight = "neutral-light",
}
